import {giantPumpkin} from '../../data/guides/giant-pumpkin.mjs';
// Old shared-page links still lead to the same giant-growing advice.
export function legacyGiantTarget(query,hash='') {
  if(typeof query.giantPhase!=='string' && !hash.startsWith('#giant'))return null;
  const phase=giantPumpkin.phases.some(p=>p.id===query.giantPhase)?query.giantPhase:'plan';
  const next={...query,phase};delete next.giantPhase;
  return {path:'/manuals/tykva-gigantskaya',query:next,hash:'#giant-pumpkin'};
}
